export const OVERVIEW_DUMMY_DATA = [
  {
    avatarUrl: "/img/widgets/people/person-female-5.png",
    name: "Hannah Müller",
    subtitle: "Updated a page",
    label: "April 9, 2025",
  },
  {
    avatarUrl: "/img/widgets/people/person-male-10.png",
    name: "Mateo Silva",
    subtitle: "Created a page",
    label: "April 16, 2025",
  },
  {
    avatarUrl: "/img/widgets/people/person-female-6.png",
    name: "Chloe Dubois",
    subtitle: "Created a page",
    label: "March 23, 2025",
  },
];
